import { render, staticRenderFns } from "./LayoutsContentView.vue?vue&type=template&id=158be01c&scoped=true"
import script from "./LayoutsContentView.vue?vue&type=script&lang=js"
export * from "./LayoutsContentView.vue?vue&type=script&lang=js"
import style0 from "./LayoutsContentView.vue?vue&type=style&index=0&id=158be01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158be01c",
  null
  
)

export default component.exports